module.exports = __webpack_public_path__ + "img/introduce.d053a092.png";